import type { MessageKey } from 'types/LocaleMessageKey';

interface HardwarePDPFAQItem {
  question: MessageKey;
  answer: MessageKey;
  list?: MessageKey;
  link?: string;
}

export const hardwarePDPFAQData: HardwarePDPFAQItem[] = [
  {
    question: 'ring_pdp_2025_faq_1_question',
    answer: 'ring_pdp_2025_faq_1_answer',
  },
  {
    question: 'ring_pdp_2025_faq_2_question',
    answer: 'ring_pdp_2025_faq_2_answer',
  },
  {
    question: 'ring_pdp_2025_faq_3_question',
    answer: 'ring_pdp_2025_faq_3_answer',
    list: 'ring_pdp_2025_faq_3_list',
  },
  {
    question: 'ring_pdp_2025_faq_4_question',
    answer: 'ring_pdp_2025_faq_4_answer',
  },
  {
    question: 'ring_pdp_2025_faq_5_question',
    answer: 'ring_pdp_2025_faq_5_answer',
    link: 'sizing',
  },
];
